import Typography from '@mui/material/Typography';

export const NoResultsMessage = () => (
  <Typography pt={20} align="center" variant="h6" color="textSecondary">
    Nothing found. Please try adjusting your filters.
  </Typography>
);

export default NoResultsMessage;
